import { ControllerContextKey } from "../controls/contexts/contextKeys";
import { GameState } from "../state/game-state";
import { getHandler } from "../state/server-message-handler";
import { TextMenu } from "./menu";
import { MenuKeys } from "./menu-keys";
import { toggleFullScreen } from "../utilities/toggle-fullscreen";
import { WsConnection } from "../utilities/ws-connection";
import { getCookie, setCookie } from "../utilities/cookies";

const DEFAULT_MAP_ID = 1;
const PLAYER_COOKIE = "player_id";

async function ensurePlayerId(): Promise<number> {
  const existing = getCookie(PLAYER_COOKIE);
  if (existing) {
    const id = Number(existing);
    if (Number.isFinite(id) && id > 0) return id;
  }
  const res = await fetch("/guest", { method: "POST" });
  if (!res.ok) {
    throw new Error("Failed to create guest");
  }
  const data = (await res.json()) as { id: number };
  setCookie(PLAYER_COOKIE, String(data.id));
  return data.id;
}

function getMapIdFromUrl(): number {
  const mapParam = new URLSearchParams(window.location.search).get("map");
  const mapId = Number(mapParam);
  return Number.isFinite(mapId) && mapId > 0 ? mapId : DEFAULT_MAP_ID;
}

export const getPreStartMenu = (container: HTMLElement, gameState: GameState) =>
  new TextMenu(container, "Menu", [
    {
      display: "Toggle Full Screen",
      action: () => {
        toggleFullScreen();
      },
    },
    {
      display: "Go Online",
      action: (ctx) => {
        if (!ctx) return;
        void (async () => {
          try {
            const playerId = await ensurePlayerId();
            const mapId = getMapIdFromUrl();

            gameState.setLocalPlayerId(playerId);
            const socketConnection = new WsConnection(playerId, mapId);
            const handler = getHandler(gameState);
            socketConnection.setMessageDataHandler(handler);

            ctx.controller.gameContext.wsConnection = socketConnection;
            ctx.menuManager.closeMenu(MenuKeys.PreStartMenu);
            ctx.controller.replaceContext(ControllerContextKey.NetworkGameplay);

            socketConnection.connect();
          } catch (e) {
            console.error("Failed to go online:", e);
          }
        })();
      },
    },
  ]);
